<template>
    <transition name="fade">
        <div v-show="isReady" class="wrapper" :class="{ 'is-modal-open': modal.isOpen, 'is-debug': config.debug }" id="app">

            <DefaultHeader v-if="selectedPage !== Sections.INFO"
                           :language="config.language"
                           :languages="config.languages"
                           :hero="event.hero.default" :logo="event.logo.default" :select="languageChanged" />
            <InfoHeader v-if="selectedPage === Sections.INFO"
                        :language="config.language"
                        :languages="config.languages"
                        :hero="event.info.logo.default" :logo="event.logo.default" :select="languageChanged" />

            <Modal :data="modal" :image="modal.image.modal" :sections="event.sections" :location="event.location" @close="closeModal" />
            <InfoModal v-bind="infoModal" @close="closeInfoModal" />

            <transition name="fade">
                <main class="main frame-medium" v-if="selectedPage === Sections.MENU">

                    <h2 class="main__headline remove-t-margin">{{ bclang('Ich esse:') }}</h2>

                    <Selector
                        ref="selector"

                        :ranges="event.ranges"

                        :diets="event.diets"
                        :intolerances="event.filteredIntolerances"
                        :filterResultsCount="count"
                        :filtersOrder="event.filtersOrder"

                        @change="selectionChanged"
                        @info="showInfo"
                    />

                    <div v-if="count">
                        <h2 class="main__headline remove-b-margin">{{ bclang('{0} Gerichte für Dich', count) }}:</h2>

                        <Category v-for="category in event.categories" :key="category.name" :sections="event.sections"
                                  :data="category" @select-dish="selectDish"/>
                    </div>

                    <div v-else>
                        <h2 class="main__headline remove-b-margin">{{ bclang('Tut uns leid, wir haben leider keine Angebote für Dich') }}</h2>
                    </div>

                </main>
                <Program v-if="selectedPage === Sections.PROGRAM && event && !event.disableProgram" :data="event ? event.program: {}"/>

                <MapBox v-if="selectedPage === Sections.MAP && !event.map.isUseImage && event && !event.disableMap" :styleObject="mapStyleObject" :sections="event.sections" :location="event.location" />
                <Hero :image="event.map.image.default" v-if="selectedPage === Sections.MAP && event.map.isUseImage && event && !event.disableMap" />

                <Info v-if="selectedPage === Sections.INFO  && event && !event.disableInformation" :data="event ? event.info : {}" />
            </transition>

<!--            <footer class="footer frame-h-medium" v-if="selectedPage === Sections.MENU">-->

<!--                <ul class="footer-links list-reset">-->
<!--                    <li class="footer-links__item" v-for="(name, link) in footerLinks" :key="name">-->
<!--                        <a class="footer-links__link" :href="name" target="_blank">{{ link }}</a>-->
<!--                    </li>-->
<!--                </ul>-->

<!--                <a :href="config.links.home" target="_blank">-->
<!--                    <svgicon icon="bc-logo" class="footer__svg" color="currentColor"></svgicon>-->
<!--                </a>-->

<!--            </footer>-->
            <BottomNavigation :selected-page="selectedPage" @select="selectPage" :data="event"/>

            <CookieLayer class="is-inverted" :text="cookieText" />
        </div>
    </transition>
</template>

<script>

    import axios from 'axios';
    import processJSON from './js/process-json.js';
    import heroImage from './img/hero.jpg';
    import config from './config.json';
    import debug from './js/debug.js';
    import debounce from 'lodash/debounce';
    import BottomNavigation from "./components/BottomNavigation";
    import Program from "./components/Program";
    import MapBox from "BerlinCuisineMap";
    import Sections from "./constants/sections";
    import Info from "./components/Info";
    import DefaultHeader from "./components/DefaultHeader";
    import InfoHeader from "./components/InfoHeader";
    import Vue from "vue";

    export default {
    name: 'app',
    components: {InfoHeader, DefaultHeader, Info, Program, BottomNavigation, MapBox },
    created() {
        this.load(this.$config.jsonUrl);
    },
    data() {
        return {
            isReady: false,
            config,
            heroImage,
            footerLinks: [],
            cookieText: '',
            selection: {
                diet: null,
                intolerances: []
            },
            event: {
                hero: {},
                logo: {},
                intolerances: [],
                categories: [],
                diets: [],
                locations: [],
                dishes: [],
                disableMap: false,
                disableInformation:false,
                disableProgram: false
            },
            modal: {
                title: '',
                station: {
                    name: '',
                },
                intolerances: null,
                image: {},
            },
            // modal: {
            //     title: 'Title',
            //     // notes: 'Sed do eiusmod tempor incididunt. ',
            //     notes: '',
            //     detail: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt. ',
            //     station: {
            //         name: 'F1 Foodtruck',
            //         title: 'Foodtruck',
            //         label: 'F1',
            //     },
            //     intolerances: [
            //         { key: 'One', title: 'One' },
            //         { key: 'Two', title: 'Two' },
            //         { key: 'Three', title: 'Three' },
            //     ],
            //     image: {},
            //     isOpen: true,
            // },
            infoModal: {
                text: '',
            },
            selectedPage : Sections.MENU,
            mapStyleObject: {
                height: "calc(70vh)"
            },
            Sections
        }
    },
    computed: {
        count() {
            const fom = this.event.categories.reduce((acc, cat) => {
                return acc += cat.filteredDishes.length;
            }, 0);

            return fom;
        },
        // logoPath() {
        //     if (this.selectedPage === Sections.INFO) {
        //         return this.event.info.logo.default;
        //     }
        //     return this.event.logo.default;
        // }
    },
    methods: {
        showInfo(info) {

            const texts = {
                breadunits: {
                    headline: this.bclang('Broteinheit (BE)'),
                    text: `
                        ${this.bclang('Die Broteinheit (BE) ist eine Berechnungseinheit für den Gehalt bestimmter Kohlenhydrate in Speisen.')}
                        <footer>
                            ${this.bclang('Eine Broteinheit entspricht 12 Gramm Kohlenhydraten.')}
                        </footer>
                    `,
                },
                kcals: {
                    headline: 'Kalorien (kcal)',
                    text: `
                        ${this.bclang('Die Energie in Lebensmitteln wird auch als Brennwert bezeichnet und in der Einheit Kalorie oder Joule gemessen.')}
                        <footer>
                            ${this.bclang('Wenn umgangssprachlich von Kalorien gesprochen wird, sind damit eigentlich Kilokalorien (1000 Kalorien) gemeint.')}
                        </footer>
                    `,
                },

            }

            const text = texts[info];

            this.infoModal = Object.assign(text, { isOpen: true });

            document.body.classList.add('is-modal-open');
        },
        load(url) {
            this.isReady = false;
            axios.get(url)
                .then(response => {
                    // processJSON(response.data);
                    // return;
                    this.event = processJSON(response.data);
                    this.$config.language = response.data.language;
                    this.$config.languages = response.data.languages;
                    Vue.set(this.config, 'language', response.data.language);
                    Vue.set(this.config, 'languages', response.data.languages);
                    this.isReady = true;

                    this.cookieText = this.bclang('Die Zutaten unserer Website? Liebe und Cookies – mehr dazu erfährst du {0}hier{1}', '<a href="https://www.berlin-cuisine.com/impressum/" target="_blank">', "</a>");
                    this.footerLinks = {
                        [this.bclang('Datenschutz')]: this.bclang('https://www.berlin-cuisine.com/datenschutz/'),
                        [this.bclang('Impressum')]: this.bclang('https://www.berlin-cuisine.com/impressum/'),
                    };

                    const lastPath = location.pathname.split('/').filter(i => !!i).reverse()[0];
                    const infoPath = this.event.info.path;

                    if (!!lastPath && lastPath === infoPath) {
                        this.selectPage(Sections.INFO);
                    }
                });
        },
        selectPage: function (page) {
            console.log(`page selected: ${page}`);
            this.selectedPage = page;
        },
        getActiveTimespan(category) {
            if (!category.timespans.length || debug.disableTimeFilter) {
                return {
                    begin: 0,
                    end: 0,
                };
            }

            const now = debug.date();

            let rtn = null;

            category.timespans.forEach(timespan => {
                const matching = now >= timespan.begin && now < timespan.end;
                if (matching) {
                    rtn = timespan;
                }
            });

            return rtn;
        },
        isActive(category) {
            return this.getActiveTimespan(category) !== null;
        },
        languageChanged(label, url) {
            this.load(url);
        },
        // selectionChanged: debounce(function(selection) {
        selectionChanged: function(selection) {
            this.selection = selection;
            this.event.categories.forEach(cat => {
                const activeTimespan = cat.activeTimespan = this.getActiveTimespan(cat);

                cat.filteredDishes = activeTimespan !== null
                    ? this.applySelection(cat.dishes)
                    : [];
            });

            this.event.filteredIntolerances = this.event.intolerances.filter(intolerance => {
                return this.selection.diet.inactiveIntolerances.indexOf(intolerance.key) === -1;
            });
        // }, 500),
        },
        filterByDiet(dish) {
            return this.selection.diet.allowed.indexOf(dish.diet) >= 0;
        },
        filterByAdditionalFilter(dish) {

            if (this.selection.diet.id !== null) {
                return true;
            } else {
                let filterName = this.selection.diet.name;
                // Example: dish.noPork == true
                return dish[filterName];
            }
        },
        filterSliders(dish) {
            // return this.selection.breadUnits >= dish.breadUnits && this.selection.kcals >= dish.kcals;
            return true;
        },
        filterByIntolerances(dish) {
            const sIntolerances = this.selection.intolerances;
            const dIntolerances = (dish.intolerances || []);

            if (!dIntolerances.length) {
                return true;
            }

            let allowed = true;

            dIntolerances.forEach(di => {
                if (sIntolerances.indexOf(di) >= 0) {
                    allowed = false;
                }
            });

            return allowed;
        },
        // TODO: filtering and categorizing logic crap
        applySelection(collection) {
            return collection
                .filter(this.filterByDiet)
                .filter(this.filterByAdditionalFilter)
                .filter(this.filterByIntolerances)
                .filter(this.filterSliders)
        },
        applyDate(collection) {
            return collection;
        },
        selectDish(item) {
            this.modal = Object.assign({}, item, { isOpen: true });
            document.body.classList.add('is-modal-open');
        },
        closeModal(item) {
            this.modal.isOpen = false;
            document.body.classList.remove('is-modal-open');
        },
        closeInfoModal(item) {
            this.infoModal.isOpen = false;
            document.body.classList.remove('is-modal-open');
        },
    }
}
</script>
